import React from 'react';
import { Text, View } from 'react-native';
import { Tooltip } from '../Tooltip';
import { StyleSheet } from 'react-native-unistyles';
import SolidButton from '../SolidButton';
import Unicon from '../Unicon';

const ToggleInput = ({ items, title = null, disabled = false, disabledItems = [], selectedValues = [], onItemChanged, itemsPerRow = null, enableSelectAll = false, icons = null, onSelectAll, testID = null }) => {

    const renderItems =  items?.map((item) => {
        if(typeof item !== 'object'){
            item = {
                label: item,
                value: item
            }
        }

        const isSelected = selectedValues?.indexOf(item.value) > -1;
        const isItemDisabled = disabled || disabledItems.includes(item.value);

        return <Tooltip
            title={icons ? item.label : null}
            key={"MultiSelectBubble_" + item.value + "_" + item.label}
            testID={testID ? `${testID}-${item.value}` : null}
            onPress={() => {
                if(isItemDisabled){
                    return false;
                }

                onItemChanged(item.value, !selectedValues?.includes(item.value))
            }} 
            style={styles.items(itemsPerRow, icons, items, isSelected, isItemDisabled)}>
                {icons && <Unicon library='fa5' name={icons[items.indexOf(item.value)]} size={12} colorVariant={isSelected ? "primary" : "secondary"}/>}
                {!icons && <Text style={styles.itemText(isSelected, isItemDisabled)}>{item.label}</Text>}
        </Tooltip>
    })


    return(
        <View style={styles.container}>
            <View style={styles.header}>
                {title && <Text style={styles.title}>{title}</Text>}
                {enableSelectAll &&
                    <SolidButton 
                        size='sm'
                        variant="outlined"
                        type={selectedValues?.filter(v => v).length == items.length ? "error" : "primary"}
                        iconName={selectedValues?.filter(v => v).length == items.length ? "close" : "checkmark-done-outline"} 
                        iconBefore 
                        text={selectedValues?.filter(v => v).length == items.length ? "Clear" : "Select All"} 
                        onPress={() => {
                            if(disabled){
                                return false;
                            }

                            const allSelected = selectedValues?.filter(v => v).length == items.length;

                            const formatted = items.map(item => {
                                if(typeof item !== 'object'){
                                    return {
                                        label: item,
                                        value: item
                                    }
                                }
                                else{
                                    return item
                                }
                            })

                             onSelectAll?.(formatted, allSelected ? false : true)
                        }}
                    />
                }
            </View>
            <View style={styles.itemContainer(itemsPerRow, items)}>
                {renderItems}
            </View>
        </View>
    )
}


const styles = StyleSheet.create(({colors, fonts, spacing, typography, roundness}) => ({
    container: {
        marginVertical: spacing.sm,
    },
    header: {
        flexDirection: "row", 
        alignItems: "center", 
        justifyContent: "space-between",
        paddingBottom: 6,
    },
    title: {
        color: colors.textSecondary, 
        fontSize: 13, 
        textAlign: "left", 
        paddingLeft: 2, 
        textTransform: "uppercase", 
        fontFamily: fonts.heading, 
        paddingBottom: 8,
    },
    selectAllButton: (allSelected, disabled) => ({
        paddingVertical: 5, 
        paddingHorizontal: 10, 
        alignItems: "center", 
        backgroundColor: colors.primary, 
        borderRadius: 8, 
        opacity: disabled ? 0.5 : 1,
    }),
    selectAllText: {
        color: colors.onPrimary, 
        fontSize: typography.caption,
    },
    items: (itemsPerRow, icons, items, isSelected, isDisabled) => ({
        margin: -(2 / itemsPerRow),
        width: icons ? 42 : itemsPerRow ? (100 / itemsPerRow) - 1 + "%" : (100 / items.length) - 1 + "%",
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: 11,
        flexGrow: 1,
        backgroundColor: isSelected ? colors.primary : colors.surface,
        flexDirection: "row",
        gap: 5,
        opacity: isDisabled ? 0.6 : 1,
        _web: {
            transition: "all 0.15s ease",
            cursor: isDisabled ? "not-allowed" : "pointer",
        }
    }),
    itemText: (isSelected, isDisabled) => ({
        textAlign: "center",
        color: isSelected ? colors.onPrimary : colors.text,
        fontSize: typography.caption,
        fontFamily: isSelected ? fonts.bold : fonts.body,
        opacity: isDisabled ? 0.7 : 1,
    }),
    itemContainer: (itemsPerRow, items) => ({
        flexDirection: "row", 
        justifyContent: "flex-start", 
        gap: (itemsPerRow || items?.length) > 5 ? 1 : 3, 
        overflow: "hidden", 
        flexWrap: "wrap", 
        borderRadius: roundness.sm, 
        borderWidth: 1, 
        borderColor: colors.border, 
        backgroundColor: colors.surface, 
    })
}));

export default React.memo(ToggleInput)